'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var templateData = _interopRequireWildcard(_templateData);

var _semanticUiReact = require('semantic-ui-react');

var _constants = require('../../constants');

require('./SocialEditor.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./SocialEditor.scss');

var SocialEditor = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    primary_color: state.templateData.primary_color,
    personal_info: state.templateData.personal_info
  };
}, {
  updatePersonalDetails: templateData.updatePersonalDetails,
  showSocialEditor: templateData.showSocialEditor
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SocialEditor, _Component);

  function SocialEditor(props) {
    (0, _classCallCheck3.default)(this, SocialEditor);

    // const {  } = this.props;
    var _this = (0, _possibleConstructorReturn3.default)(this, (SocialEditor.__proto__ || (0, _getPrototypeOf2.default)(SocialEditor)).call(this, props));

    _this.handleChange = function (e, _ref) {
      var name = _ref.name,
          value = _ref.value;


      _this.setState((0, _defineProperty3.default)({}, name, value));
    };

    _this.addDataPoint = function () {
      var _this$state = _this.state,
          newSocial = _this$state.newSocial,
          newValue = _this$state.newValue,
          socialDataArray = _this$state.socialDataArray;

      var newSocialDataArray;
      //checking if socialDataArray is empty
      if (socialDataArray) {
        newSocialDataArray = [].concat((0, _toConsumableArray3.default)(socialDataArray), [{ "social": newSocial, "value": newValue }]);
      } else {
        newSocialDataArray = [{ "social": newSocial, "value": newValue }];
      }
      // const socialDataArrayString = newSocialDataArray;
      // this.props.updatePersonalDetails(socialDataArrayString, 'social_data');
      _this.setState({ socialDataArray: newSocialDataArray });
    };

    _this.deleteDataPoint = function (e, index) {
      var _this$state2 = _this.state,
          newSocial = _this$state2.newSocial,
          newValue = _this$state2.newValue,
          socialDataArray = _this$state2.socialDataArray;


      socialDataArray.splice(index, 1);
      // const socialDataArrayString = socialDataArray
      // this.props.updatePersonalDetails(socialDataArrayString, 'social_data');
      _this.setState({ socialDataArray: socialDataArray });
    };

    _this.handleInputChange = function (e, data, index, type) {
      var socialDataArray = _this.state.socialDataArray;


      socialDataArray[index][type] = data.value;

      _this.setState(socialDataArray);
      // const socialDataArrayString = socialDataArray
      // this.props.updatePersonalDetails(socialDataArrayString, 'social_data');
    };

    _this.handleClose = function () {
      _this.props.updatePersonalDetails(_this.state.socialDataArray, 'social_data');
      _this.props.showSocialEditor(false);
    };

    _this.state = {
      newSocial: '',
      newValue: '',
      socialDataArray: []
    };
    return _this;
  }

  (0, _createClass3.default)(SocialEditor, [{
    key: 'componentWillMount',
    value: function componentWillMount() {

      var data;
      var social_data = false;
      if (this.props.personal_info.social_data) {
        social_data = this.props.personal_info.social_data;
      }

      if (social_data) {
        data = social_data;
      } else {
        data = false;
      }

      this.setState({ socialDataArray: data });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // const { chartX, chartY, data_parent, data_id, data_typ } = this.props;
      var _state = this.state,
          newSocial = _state.newSocial,
          newValue = _state.newValue,
          socialDataArray = _state.socialDataArray;


      return _react2.default.createElement(
        _semanticUiReact.Form,
        { size: 'small', style: { borderRadius: '5px' } },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { style: { padding: '15px' }, clearing: true, raised: false },
          _react2.default.createElement(
            _semanticUiReact.Header,
            { floated: 'left' },
            'Enter Your Contact/Social Details'
          ),
          _react2.default.createElement(
            _semanticUiReact.Header,
            { floated: 'right' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', onClick: this.handleClose })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'socialEditor', style: { padding: '30px' } },
          socialDataArray && socialDataArray.map(function (socialObject, index) {
            return _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { key: index + 1 },
              _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
                label: 'Social-' + (index + 1),
                width: 7,
                placeholder: 'Select Icon',
                fluid: true,
                search: true,
                selection: true,
                options: _constants.SOCIAL_OPTIONS,
                value: socialObject.social,
                onChange: function onChange(e, data) {
                  return _this2.handleInputChange(e, data, index, 'social');
                }
              }),
              _react2.default.createElement(_semanticUiReact.Form.Input, {
                label: 'Value-' + (index + 1),
                width: 10,
                placeholder: 'value',
                value: socialObject.value,
                onChange: function onChange(e, data) {
                  return _this2.handleInputChange(e, data, index, 'value');
                }
              }),
              _react2.default.createElement(_semanticUiReact.Form.Button, { style: { marginTop: '22px', width: '84px' }, onClick: function onClick(e) {
                  return _this2.deleteDataPoint(e, index);
                }, content: 'Delete' })
            );
          }),
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            null,
            _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
              label: 'Add New Social',
              width: 7,
              fluid: true,
              search: true,
              selection: true,
              options: _constants.SOCIAL_OPTIONS,
              name: 'newSocial',
              value: newSocial,
              onChange: this.handleChange
            }),
            _react2.default.createElement(_semanticUiReact.Form.Input, {
              label: 'Add New Value',
              width: 10,
              placeholder: 'Enter Value',
              name: 'newValue',
              value: newValue,
              onChange: this.handleChange
            }),
            _react2.default.createElement(_semanticUiReact.Form.Button, {
              secondary: true,
              style: { marginTop: '22px', width: '84px' },
              onClick: this.addDataPoint,
              content: 'Add'
            })
          )
        )
      );
    }
  }]);
  return SocialEditor;
}(_react.Component)) || _class);
exports.default = SocialEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialEditor/SocialEditor.js
// module id = 1748
// module chunks = 0